import React from "react";
import {Route} from "react-router-dom";
import InsertAccount from "../../pages/maintenanceAccounts/insertAccount";
import EditAccount from "../../pages/maintenanceAccounts/editAccount";
import {EDIT_ACCOUNT_ROUTE, INSERT_ACCOUNT_ROUTE} from "../../utils/constants/RoutesConstants";

const MaintenanceAccountsRoutes = () => {
    return (
        <React.Fragment>
            <Route path={INSERT_ACCOUNT_ROUTE} component={InsertAccount}/>
            <Route path={EDIT_ACCOUNT_ROUTE} component={EditAccount}/>
        </React.Fragment>
    );
};

export default MaintenanceAccountsRoutes;